module.exports = __webpack_public_path__ + "img/entityEle.91b66d49.svg";